import { Polygon } from "@vis.gl/react-google-maps/dist/index.umd.js";
import React, { Component } from "react";

class PoligonoMundo extends Component {
  constructor() {
    super();

    this.state = {
      coordenadas: [
        { lat: -85.1054596961173, lng: -180 },
        { lat: 85.1054596961173, lng: -180 },
        { lat: 85.1054596961173, lng: 180 },
        { lat: -85.1054596961173, lng: 180 },
        { lat: -85.1054596961173, lng: 0 },
      ],
      propriedades: {
        strokeColor: "#000000",
        strokeOpacity: 0.5,
        strokeWeight: 2,
        fillColor: "#000000",
        fillOpacity: 0.5,
        zIndex: -2,
        cursor: "grab",
      },
    };
  }

  render() {
    return (
      <Polygon
        paths={this.state.coordenadas}
        options={{
          ...this.state.propriedades,
        }}
        onClick={this.props.onClick}
        onMouseMove={this.props.onMouseMove}
        onMouseOver={this.props.onMouseOver}
      />
    );
  }
}

export default PoligonoMundo;
